module.exports = __webpack_public_path__ + "static/img/howto-explain08.acd6599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/howto/howto-explain08.png
// module id = adND
// module chunks = 1